/**
 * To uphold security practices, this function defaults to opening external URLs with the 'noopener' attribute
 * If there is a need to open an external URL WITHOUT the 'noopener' attribute, it is recommended to use window.open directly in the code
 * The 'noreferrer' attribute is not enforced to allow Amex links to track the referrer.
*/
const openExternalUrl = (externalUrl) => {
  window.open(externalUrl, '_blank', 'noopener');
};

export default openExternalUrl;
